var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg7DaysIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33337 1.33301V3.33301",
    stroke: "#9EA3AE",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 1.33301V3.33301",
    stroke: "#9EA3AE",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 2.33301C12.8867 2.45301 14 3.29967 14 6.43301V10.553C14 13.2997 13.3333 14.673 10 14.673H6C2.66667 14.673 2 13.2997 2 10.553V6.43301C2 3.29967 3.11333 2.45967 5.33333 2.33301H10.6667Z",
    stroke: "#9EA3AE",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 11.7334H2.16663",
    stroke: "#9EA3AE",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 5.5C7.18004 5.5 6.48671 5.94667 6.48671 6.81333C6.48671 7.22667 6.68004 7.54 6.97337 7.74C6.56671 7.98 6.33337 8.36667 6.33337 8.82C6.33337 9.64667 6.96671 10.16 8.00004 10.16C9.02671 10.16 9.66671 9.64667 9.66671 8.82C9.66671 8.36667 9.43337 7.97333 9.02004 7.74C9.32004 7.53333 9.50671 7.22667 9.50671 6.81333C9.50671 5.94667 8.82004 5.5 8.00004 5.5ZM8.00004 7.39333C7.65337 7.39333 7.40004 7.18667 7.40004 6.86C7.40004 6.52667 7.65337 6.33333 8.00004 6.33333C8.34671 6.33333 8.60004 6.52667 8.60004 6.86C8.60004 7.18667 8.34671 7.39333 8.00004 7.39333ZM8.00004 9.33333C7.56004 9.33333 7.24004 9.11333 7.24004 8.71333C7.24004 8.31333 7.56004 8.1 8.00004 8.1C8.44004 8.1 8.76004 8.32 8.76004 8.71333C8.76004 9.11333 8.44004 9.33333 8.00004 9.33333Z",
    fill: "#9EA3AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7DaysIcon);
export default __webpack_public_path__ + "static/media/7-days-icon.48bf35a04ed3c6b1b088790b7431852b.svg";
export { ForwardRef as ReactComponent };